import { render, staticRenderFns } from "./AccountContactSection.vue?vue&type=template&id=08f44507"
import script from "./AccountContactSection.vue?vue&type=script&lang=js"
export * from "./AccountContactSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports